import { ResetPasswordDetails } from "../types/resetPasswordTypes";

export const resetPasswordInitialValues: ResetPasswordDetails = {
  password: "",
  confirmPassword: "",
  captchaToken: "",
};
